import React from 'react';
import { Link } from 'react-router-dom';
import { accountService } from '../_services';

function Overview({ match }) {
    const { path } = match;

    return (
        <div className="card admin-rad">

            <div className="card-header header-admin admin-btm-bdr">
                <h1 className="bold-tx">Admin</h1>
                <h5 className="mar-bot-0">This area is only accessible to venue administrators</h5>
            </div>

            <Link className="home-btn admin-menu-btn admin-menu-first" to={`${path}/users`}><h3>Manage Users</h3></Link>
            <br />
            <Link className="home-btn home-rsv-btn" to={`${path}/reservations`}><h3>Manage Reservations</h3></Link>
            <br />
            <Link onClick={accountService.logout} to="/" className="home-btn home-logout-btn home-btn-last">
                <h5>Logout</h5>
            </Link>

            {/*<p><Link to={`${path}/lockers`}>Manage Lockers</Link></p>*/}

        </div>
    );
}

export { Overview };